import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
function RevealBlock({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const ref = useScrollReveal<HTMLDivElement>();
  return <div ref={ref} className={`opacity-0 translate-y-10 transition-all duration-700 ease-out ${className}`} data-id="element-168">
      {children}
    </div>;
}
export function PainSection() {
  return <section className="bg-blanco-hueso py-20 px-5" data-id="element-169">
      <div className="max-w-[760px] mx-auto" data-id="element-170">
        <RevealBlock data-id="element-171">
          <p className="text-[0.8rem] font-bold tracking-[2px] uppercase text-verde-bosque mb-3 flex items-center gap-2" data-id="element-172">
            <span className="w-6 h-0.5 bg-verde-bosque rounded-sm" data-id="element-173" />
            ¿Te sientes identificada?
          </p>
        </RevealBlock>

        <RevealBlock data-id="element-174">
          <h2 className="font-display font-bold text-negro-carbon leading-[1.25] mb-6" style={{
          fontSize: 'clamp(1.6rem, 4vw, 2.4rem)'
        }} data-id="element-175">
            ¿Tu cuerpo ya no responde
            <br data-id="element-176" />
            como antes y{' '}
            <span className="text-verde-bosque" data-id="element-177">no sabes por qué?</span>
          </h2>
        </RevealBlock>

        <RevealBlock data-id="element-178">
          <p className="text-[1.1rem] text-gray-700 mb-8 leading-[1.8]" data-id="element-179">
            No es falta de disciplina. No es la edad. Y definitivamente no es tu
            culpa. Si tienes más de 45 años, algo cambió silenciosamente en tu
            biología que ningún médico te ha explicado con claridad. Lee esto
            con atención:
          </p>
        </RevealBlock>

        <RevealBlock data-id="element-180">
          <ul className="list-none flex flex-col gap-3.5 mb-9" data-id="element-181">
            <li className="flex items-start gap-3.5 bg-white py-[18px] px-5 rounded-card border-l-4 border-rojo-urgencia shadow-[0_2px_12px_rgba(0,0,0,0.05)] text-[0.97rem] text-gray-700 transition-all duration-300 hover:translate-x-1 hover:shadow-[0_4px_20px_rgba(0,0,0,0.1)]" data-id="element-182">
              <span className="text-[1.1rem] flex-shrink-0 mt-0.5" data-id="element-183">😔</span>
              <span data-id="element-184">
                Te despiertas{' '}
                <strong data-id="element-185">inflamada aunque hayas cenado ligero</strong>, y tu ropa
                de la cintura para arriba ya no cierra igual.
              </span>
            </li>
            <li className="flex items-start gap-3.5 bg-white py-[18px] px-5 rounded-card border-l-4 border-rojo-urgencia shadow-[0_2px_12px_rgba(0,0,0,0.05)] text-[0.97rem] text-gray-700 transition-all duration-300 hover:translate-x-1 hover:shadow-[0_4px_20px_rgba(0,0,0,0.1)]" data-id="element-186">
              <span className="text-[1.1rem] flex-shrink-0 mt-0.5" data-id="element-187">😔</span>
              <span data-id="element-188">
                Haces dieta, reduces carbohidratos, pruebas el ayuno
                intermitente... pero tu{' '}
                <strong data-id="element-189">abdomen sigue igual o peor.</strong>
              </span>
            </li>
            <li className="flex items-start gap-3.5 bg-white py-[18px] px-5 rounded-card border-l-4 border-rojo-urgencia shadow-[0_2px_12px_rgba(0,0,0,0.05)] text-[0.97rem] text-gray-700 transition-all duration-300 hover:translate-x-1 hover:shadow-[0_4px_20px_rgba(0,0,0,0.1)]" data-id="element-190">
              <span className="text-[1.1rem] flex-shrink-0 mt-0.5" data-id="element-191">😔</span>
              <span data-id="element-192">
                A las <strong data-id="element-193">3 o 4 de la tarde tu energía cae al suelo</strong>{' '}
                y lo único que quieres es algo dulce o pan.
              </span>
            </li>
            <li className="flex items-start gap-3.5 bg-white py-[18px] px-5 rounded-card border-l-4 border-rojo-urgencia shadow-[0_2px_12px_rgba(0,0,0,0.05)] text-[0.97rem] text-gray-700 transition-all duration-300 hover:translate-x-1 hover:shadow-[0_4px_20px_rgba(0,0,0,0.1)]" data-id="element-194">
              <span className="text-[1.1rem] flex-shrink-0 mt-0.5" data-id="element-195">😔</span>
              <span data-id="element-196">
                Tu <strong data-id="element-197">mente está en niebla</strong>, te cuesta concentrarte
                y sientes que no eres la misma persona de hace 5 años.
              </span>
            </li>
            <li className="flex items-start gap-3.5 bg-white py-[18px] px-5 rounded-card border-l-4 border-rojo-urgencia shadow-[0_2px_12px_rgba(0,0,0,0.05)] text-[0.97rem] text-gray-700 transition-all duration-300 hover:translate-x-1 hover:shadow-[0_4px_20px_rgba(0,0,0,0.1)]" data-id="element-198">
              <span className="text-[1.1rem] flex-shrink-0 mt-0.5" data-id="element-199">😔</span>
              <span data-id="element-200">
                A las 9 PM tu cuerpo{' '}
                <strong data-id="element-201">pide azúcar o carbohidratos</strong> con una intensidad
                que no puedes controlar, aunque "no tengas hambre".
              </span>
            </li>
            <li className="flex items-start gap-3.5 bg-white py-[18px] px-5 rounded-card border-l-4 border-rojo-urgencia shadow-[0_2px_12px_rgba(0,0,0,0.05)] text-[0.97rem] text-gray-700 transition-all duration-300 hover:translate-x-1 hover:shadow-[0_4px_20px_rgba(0,0,0,0.1)]" data-id="element-202">
              <span className="text-[1.1rem] flex-shrink-0 mt-0.5" data-id="element-203">😔</span>
              <span data-id="element-204">
                Duermes mal, te despiertas con la{' '}
                <strong data-id="element-205">mente acelerada</strong> y por las mañanas te sientes
                más cansada que la noche anterior.
              </span>
            </li>
          </ul>
        </RevealBlock>

        <RevealBlock data-id="element-206">
          <div className="text-white p-8 rounded-card-lg mt-9 relative overflow-hidden" style={{
          background: 'linear-gradient(135deg, #2B4A42, #1C352C)'
        }} data-id="element-207">
            <div className="absolute -top-[50px] -right-[50px] w-[200px] h-[200px] rounded-full" style={{
            background: 'rgba(201, 168, 76, 0.1)'
          }} data-id="element-208" />
            <h3 className="font-display text-[1.4rem] text-oro mb-3 relative z-10" data-id="element-209">
              Si dijiste "sí" a 3 o más de estas situaciones...
            </h3>
            <p className="text-[0.97rem] text-white/[0.88] leading-[1.8] relative z-10" data-id="element-210">
              ...tu cuerpo no está fallando. Está{' '}
              <strong className="text-white" data-id="element-211">
                respondiendo exactamente como fue diseñado
              </strong>{' '}
              para responder ante una caída hormonal. El estrógeno baja, el
              cortisol sube, y tu metabolismo entra en "Modo Supervivencia".
              Almacena grasa abdominal, bloquea la quema de energía y genera
              antojos de azúcar. Es un mecanismo de defensa... que ya no
              necesitas. Y en este protocolo aprenderás a{' '}
              <strong className="text-white" data-id="element-212">
                desactivarlo en 10 minutos al día.
              </strong>
            </p>
          </div>
        </RevealBlock>
      </div>
    </section>;
}